import { Fragment, type ReactNode } from "react";

import { Anchor } from "@mantine/core";

import { NextLink } from "@/app/lib/components/next/NextLink";

/** Minimal inline formatter for marketing prose: **bold** and [text](url).
 *  Intentionally not a markdown parser: no nesting, no other syntax. */
const TOKEN = /\*\*(.+?)\*\*|\[(.+?)\]\((.+?)\)/g;

export function renderInline(text: string): ReactNode {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;
  let match: RegExpExecArray | null;

  TOKEN.lastIndex = 0;
  while ((match = TOKEN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(<Fragment key={key++}>{text.slice(lastIndex, match.index)}</Fragment>);
    }

    if (match[1] !== undefined) {
      nodes.push(<strong key={key++}>{match[1]}</strong>);
    } else {
      const label = match[2];
      const href = match[3];
      nodes.push(
        <Anchor key={key++} component={NextLink} href={href} fw={600}>
          {label}
        </Anchor>,
      );
    }

    lastIndex = TOKEN.lastIndex;
  }

  if (lastIndex < text.length) {
    nodes.push(<Fragment key={key++}>{text.slice(lastIndex)}</Fragment>);
  }

  return nodes;
}

/** Split a prose block into paragraphs on blank lines. */
export function toParagraphs(body: string): string[] {
  return body
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);
}
